import { useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import ComparisonBox from './box';
import BoxActions from './boxActions';
import messages from './messages';
import { Text, TextHiglight } from './text';

export enum BrandValue {
  SNCF_CONNECT = 'SNCF_CONNECT',
  TRAINLINE = 'TRAINLINE',
}

const ANSWERS: Record<BrandValue, number> = {
  SNCF_CONNECT: 100,
  TRAINLINE: 80,
};

const HaveFunTab = ({ intl }) => {
  const [value, setValue] = useState<string>(BrandValue.SNCF_CONNECT);
  const percentage = ANSWERS[value];

  return (
    <div>
      <ComparisonBox
        firstSelectOptions={[
          { children: intl.formatMessage(messages.withTictactrip), value: '' },
        ]}
        middleMessage={<FormattedMessage {...messages.insteadOf2} />}
        secondSelectOnChange={setValue}
        secondSelectOptions={[
          { children: 'SNCF Connect', value: BrandValue.SNCF_CONNECT },
          { children: 'Trainline', value: BrandValue.TRAINLINE },
        ]}
        secondSelectValue={value}
      />

      <Text data-testid="funPercentage">
        <FormattedMessage
          {...messages.moreLaughter}
          values={{ percentage: <TextHiglight>{percentage}%</TextHiglight> }}
        />
      </Text>

      <BoxActions
        content={<FormattedMessage {...messages.shareResults} />}
        title={<FormattedMessage {...messages.shareGoodNews} />}
      />
    </div>
  );
};

const HaveFunTabIntl = injectIntl(HaveFunTab);

export default HaveFunTabIntl;
